import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarBillListLinear from 'components/icons/SolarBillListLinear';
import SolarSunriseLinear from 'components/icons/SolarSunriseLinear';
import SolarUserLinear from 'components/icons/SolarUserLinear';
import SolarPenNewSquareLinear from 'components/icons/SolarPenNewSquareLinear';
import ReportDate from '../ReportDate';
import ReportExportButton from '../ReportExportButton';
import OffReportFilter from '../OffReportFilter';
import OffPaymentReportFilterForm from './OffPaymentReportFilterForm';
import { usePaymentReport } from './context/ReportObjectPaymentsProvider';
import type { PaymentGroupBy } from './model/reportObjectPayments';

const ReportObjectPaymentsToolBar = () => {
    const { t } = useTranslation(['Reports']);
    const report = usePaymentReport();
    const { filters } = report;
    const viewLabel = t(filters.detail ? `objectPayments.group.${filters.groupBy}` : 'objectPayments.summary');
    const viewIcons = { object: SolarSunriseLinear, owner: SolarUserLinear, author: SolarPenNewSquareLinear };
    const ViewIcon = filters.detail ? viewIcons[filters.groupBy] : SolarBillListLinear;
    return (
        <div className="mt-2 mt-sm-0 mb-2 page-toolbar-actions">
            <ReportExportButton disabled={!report.rows.length || report.isReporting || report.error} loading={report.exporting} onClick={() => void report.exportReport()} />
            <ReportDate setDates={report.setDates} initialFilter={filters.dateFilter} onFilterChange={report.changeDate} />
            {report.objectId === undefined && (
                <>
                    <Dropdown>
                        <Dropdown.Toggle size="sm" variant={filters.detail ? 'danger' : 'primary'} className="fs-14 px-2 toolbar-icon-btn" id="payment-report-view" title={viewLabel} aria-label={viewLabel}>
                            <ViewIcon width={16} height={16} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as="button" className="d-flex align-items-center" active={!filters.detail} onClick={() => report.changeView('summary')}>
                                <SolarBillListLinear width={16} height={16} className="flex-shrink-0 me-2" />
                                {t('objectPayments.summary')}
                            </Dropdown.Item>
                            {(['object', 'owner', 'author'] as PaymentGroupBy[]).map((by) => {
                                const Icon = viewIcons[by];
                                return (
                                    <Dropdown.Item key={by} as="button" className="d-flex align-items-center" active={filters.detail && filters.groupBy === by} onClick={() => report.changeView(by)}>
                                        <Icon width={16} height={16} className="flex-shrink-0 me-2" />
                                        {t(`objectPayments.group.${by}`)}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </>
            )}
            {report.objectId === undefined && <ListToolBarActions onRefresh={report.refreshReport} onReset={report.resetReport} disabled={report.isReporting} />}
            {report.objectId === undefined && (
                <OffReportFilter
                    values={filters}
                    defaults={{ ...filters, includeObjects: true, includeSales: true, includeServiceSales: true, isVat: null, selectedObject: null, owner: null, author: null }}
                    onApply={report.applyFilters}
                    active={filters.isVat !== null || !filters.includeObjects || (report.showSales && (!filters.includeSales || !filters.includeServiceSales)) || !!filters.selectedObject || !!filters.owner || !!filters.author}
                >
                    <OffPaymentReportFilterForm />
                </OffReportFilter>
            )}
        </div>
    );
};

export default ReportObjectPaymentsToolBar;
